import { useEffect, useState } from 'react';
import { useSaves } from '../state/saves';
import { useSw } from './swRegistration';

/**
 * 새 버전 알림. 자동 새로고침하지 않는다 (계획서 §17-8): 입력 중인 내용이 사라질 수 있기 때문.
 * 사용자가 '업데이트'를 누를 때만 적용하며, 저장 대기 중인 입력이 있으면 버튼을 막는다.
 * 다른 탭에서 새 버전이 저장소를 업그레이드하면 이 탭은 저장소 연결을 닫았으므로 새로고침을 안내한다.
 */
export function UpdatePrompt() {
  const update = useSw((s) => s.update);
  const pending = useSaves((x) => x.pending);
  const [dbClosed, setDbClosed] = useState(false);

  useEffect(() => {
    const on = () => setDbClosed(true);
    window.addEventListener('counselai:db-closed', on);
    return () => window.removeEventListener('counselai:db-closed', on);
  }, []);

  if (dbClosed)
    return (
      <div role="alert" className="banner warn-banner">
        다른 창에서 새 버전이 실행되었습니다. 이 창을 새로고침해 주세요.
        <button type="button" onClick={() => window.location.reload()}>
          새로고침
        </button>
      </div>
    );
  if (!update) return null;
  return (
    <div role="status" className="banner">
      새 버전이 있습니다. 작업을 저장한 뒤 적용하세요.
      <button type="button" disabled={pending > 0} onClick={() => void update(true)}>
        {pending > 0 ? '저장 중…' : '업데이트'}
      </button>
    </div>
  );
}
